// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.purchase-coins-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
}

.page-header {
  margin-bottom: 2rem;
}
.page-header .back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: none;
  background: none;
  color: #5ea1d8;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1rem;
}
.page-header h1 {
  margin: 0 0 0.5rem;
  font-size: 2rem;
  color: #0f172a;
}
.page-header .subtitle {
  margin: 0;
  color: #64748b;
  max-width: 640px;
  line-height: 1.6;
}

.balance-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.balance-strip .balance-item {
  display: flex;
  flex-direction: column;
  min-width: 120px;
}
.balance-strip .balance-item .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}
.balance-strip .balance-item .value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
}
.balance-strip .balance-item.total .value {
  color: #e83e8c;
}

.checkout-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}
@media (min-width: 900px) {
  .checkout-layout {
    grid-template-columns: 1.1fr 0.9fr;
  }
}

.pack-picker h2,
.payment-panel h2 {
  font-size: 1.1rem;
  margin: 0 0 1rem;
  color: #0f172a;
}

.pack-grid {
  display: grid;
  gap: 1rem;
}

.pack-card {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 1rem;
  width: 100%;
  text-align: left;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pack-card.selected {
  border-color: #e83e8c;
  box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.15);
}
.pack-card .pack-name {
  font-weight: 700;
  color: #0f172a;
}
.pack-card .pack-coins {
  color: #64748b;
  font-size: 0.9rem;
}
.pack-card .pack-price {
  font-weight: 700;
  color: #e83e8c;
}

.payment-panel .summary-card {
  padding: 1.25rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  margin-bottom: 1.25rem;
}
.payment-panel .summary-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0;
  color: #64748b;
}
.payment-panel .summary-row strong {
  color: #0f172a;
}
.payment-panel .summary-row.total-row {
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e2e8f0;
  font-size: 1.05rem;
}
.payment-panel .summary-note {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  color: #64748b;
}

.paypal-wrap {
  min-height: 120px;
}

.processing-note {
  margin-top: 0.75rem;
  font-size: 0.9rem;
  color: #64748b;
}

/* Dark mode — AI coin purchase checkout */
:host-context(body.theme-dark) .purchase-coins-page {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .page-header .back-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .page-header h1 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .page-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-strip {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .balance-strip .balance-item .label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-strip .balance-item .value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .balance-strip .balance-item.total .value {
  color: #f472b6 !important;
}
:host-context(body.theme-dark) .pack-picker h2,
:host-context(body.theme-dark) .payment-panel h2 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .pack-card.selected {
  border-color: #e83e8c !important;
  box-shadow: 0 0 0 1px rgba(232, 62, 140, 0.25) !important;
}
:host-context(body.theme-dark) .pack-card .pack-name {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card .pack-coins {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .pack-card .pack-price {
  color: #f472b6 !important;
}
:host-context(body.theme-dark) .payment-panel .summary-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .payment-panel .summary-row {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .payment-panel .summary-row strong {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .payment-panel .summary-row.total-row {
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .payment-panel .summary-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .processing-note {
  color: #94a3b8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/purchase-coins/purchase-coins.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMhB;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;AAME;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cApBG;EAqBH,gBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,cA7BQ;AAwBZ;AAQE;EACE,SAAA;EACA,cAjCS;EAkCT,gBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAPF;AASE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAPJ;AASI;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cA1DO;AAmDb;AAUI;EACE,kBAAA;EACA,gBAAA;EACA,cAjEM;AAyDZ;AAWI;EACE,cAvEC;AA8DP;;AAcA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAXF;AAaE;EALF;IAMI,kCAAA;EAVF;AACF;;AAaA;;EAEE,iBAAA;EACA,gBAAA;EACA,cAxFU;AA8EZ;;AAaA;EACE,aAAA;EACA,SAAA;AAVF;;AAaA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,8CAAA;AAVF;AAYE;EACE,qBAjHG;EAkHH,8CAAA;AAVJ;AAaE;EACE,gBAAA;EACA,cArHQ;AA0GZ;AAcE;EACE,cAxHS;EAyHT,iBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,cAjIG;AAoHP;;AAkBE;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,cAhJS;AAgIb;AAkBI;EACE,cApJM;AAoIZ;AAmBI;EACE,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;AAjBN;AAqBE;EACE,mBAAA;EACA,kBAAA;EACA,cAjKS;AA8Ib;;AAuBA;EACE,iBAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,iBAAA;EACA,cA5KW;AAwJb;;AAuBA,0CAAA;AAEE;EACE,yBAAA;AArBJ;AAyBI;EACE,yBAAA;AAvBN;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,yBAAA;AAzBN;AA6BE;EACE,8BAAA;EACA,kDAAA;AA3BJ;AA8BM;EACE,yBAAA;AA5BR;AA+BM;EACE,yBAAA;AA7BR;AAgCM;EACE,yBAAA;AA9BR;AAmCE;;EAEE,yBAAA;AAjCJ;AAoCE;EACE,8BAAA;EACA,kDAAA;AAlCJ;AAoCI;EACE,gCAAA;EACA,yDAAA;AAlCN;AAqCI;EACE,yBAAA;AAnCN;AAsCI;EACE,yBAAA;AApCN;AAuCI;EACE,yBAAA;AArCN;AA0CI;EACE,8BAAA;EACA,kDAAA;AAxCN;AA2CI;EACE,yBAAA;AAzCN;AA2CM;EACE,yBAAA;AAzCR;AA4CM;EACE,sDAAA;AA1CR;AA8CI;EACE,yBAAA;AA5CN;AAgDE;EACE,yBAAA;AA9CJ","sourcesContent":["$pink: #e83e8c;\n$blue: #5ea1d8;\n$text-dark: #0f172a;\n$text-light: #64748b;\n$border: #e2e8f0;\n\n.purchase-coins-page {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 2.5rem 1.5rem 4rem;\n}\n\n.page-header {\n  margin-bottom: 2rem;\n\n  .back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    border: none;\n    background: none;\n    color: $blue;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n    margin-bottom: 1rem;\n  }\n\n  h1 {\n    margin: 0 0 0.5rem;\n    font-size: 2rem;\n    color: $text-dark;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: $text-light;\n    max-width: 640px;\n    line-height: 1.6;\n  }\n}\n\n.balance-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding: 1rem 1.25rem;\n  border-radius: 12px;\n  background: #f8fafc;\n  border: 1px solid $border;\n\n  .balance-item {\n    display: flex;\n    flex-direction: column;\n    min-width: 120px;\n\n    .label {\n      font-size: 0.75rem;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      color: $text-light;\n    }\n\n    .value {\n      font-size: 1.25rem;\n      font-weight: 700;\n      color: $text-dark;\n    }\n\n    &.total .value {\n      color: $pink;\n    }\n  }\n}\n\n.checkout-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n\n  @media (min-width: 900px) {\n    grid-template-columns: 1.1fr 0.9fr;\n  }\n}\n\n.pack-picker h2,\n.payment-panel h2 {\n  font-size: 1.1rem;\n  margin: 0 0 1rem;\n  color: $text-dark;\n}\n\n.pack-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.pack-card {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  text-align: left;\n  padding: 1rem 1.25rem;\n  border-radius: 12px;\n  border: 2px solid $border;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &.selected {\n    border-color: $pink;\n    box-shadow: 0 0 0 1px rgba($pink, 0.15);\n  }\n\n  .pack-name {\n    font-weight: 700;\n    color: $text-dark;\n  }\n\n  .pack-coins {\n    color: $text-light;\n    font-size: 0.9rem;\n  }\n\n  .pack-price {\n    font-weight: 700;\n    color: $pink;\n  }\n}\n\n.payment-panel {\n  .summary-card {\n    padding: 1.25rem;\n    border-radius: 12px;\n    border: 1px solid $border;\n    background: #fff;\n    margin-bottom: 1.25rem;\n  }\n\n  .summary-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.5rem 0;\n    color: $text-light;\n\n    strong {\n      color: $text-dark;\n    }\n\n    &.total-row {\n      margin-top: 0.5rem;\n      padding-top: 0.75rem;\n      border-top: 1px solid $border;\n      font-size: 1.05rem;\n    }\n  }\n\n  .summary-note {\n    margin: 0.75rem 0 0;\n    font-size: 0.85rem;\n    color: $text-light;\n  }\n}\n\n.paypal-wrap {\n  min-height: 120px;\n}\n\n.processing-note {\n  margin-top: 0.75rem;\n  font-size: 0.9rem;\n  color: $text-light;\n}\n\n/* Dark mode — AI coin purchase checkout */\n:host-context(body.theme-dark) {\n  .purchase-coins-page {\n    color: #e2e8f0 !important;\n  }\n\n  .page-header {\n    .back-link {\n      color: #93c5fd !important;\n    }\n\n    h1 {\n      color: #f8fafc !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .balance-strip {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .balance-item {\n      .label {\n        color: #94a3b8 !important;\n      }\n\n      .value {\n        color: #f8fafc !important;\n      }\n\n      &.total .value {\n        color: #f472b6 !important;\n      }\n    }\n  }\n\n  .pack-picker h2,\n  .payment-panel h2 {\n    color: #f8fafc !important;\n  }\n\n  .pack-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &.selected {\n      border-color: $pink !important;\n      box-shadow: 0 0 0 1px rgba($pink, 0.25) !important;\n    }\n\n    .pack-name {\n      color: #f8fafc !important;\n    }\n\n    .pack-coins {\n      color: #94a3b8 !important;\n    }\n\n    .pack-price {\n      color: #f472b6 !important;\n    }\n  }\n\n  .payment-panel {\n    .summary-card {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n    }\n\n    .summary-row {\n      color: #94a3b8 !important;\n\n      strong {\n        color: #f8fafc !important;\n      }\n\n      &.total-row {\n        border-top-color: rgba(148, 163, 184, 0.28) !important;\n      }\n    }\n\n    .summary-note {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .processing-note {\n    color: #94a3b8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
